import React, { useEffect, useState } from 'react';
import Lottie from 'components/lottie/lottie.component';

import loadAnimation from 'assets/load/energy.min.json';

import {
  LoadingInvoiceContainer,
  StepText,
  StepList,
  StepItem,
} from './loading-invoice.styles';

// Espelha a ordem real do pipeline do backend (extração → distribuidora →
// dados → geração). A progressão é temporizada, pois a API é uma chamada única.
const STEPS = [
  { label: 'Lendo o PDF...', duration: 2000 },
  { label: 'Identificando a distribuidora...', duration: 2000 },
  { label: 'Extraindo os dados da fatura...', duration: 4000 },
  { label: 'Buscando a geração do seu inversor...', duration: 6000 },
  { label: 'Finalizando, quase lá...', duration: Infinity },
];

export const LoadingInvoice = () => {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    if (stepIndex >= STEPS.length - 1) return;
    const timer = setTimeout(
      () => setStepIndex((i) => i + 1),
      STEPS[stepIndex].duration
    );
    return () => clearTimeout(timer);
  }, [stepIndex]);

  return (
    <LoadingInvoiceContainer>
      <Lottie style={{ height: 150 }} animationData={loadAnimation} />
      <StepText>{STEPS[stepIndex].label}</StepText>
      <StepList>
        {STEPS.slice(0, -1).map((step, i) => (
          <StepItem
            key={step.label}
            $done={i < stepIndex}
            $active={i === stepIndex}
          >
            {i < stepIndex ? '✓' : '•'} {step.label.replace('...', '')}
          </StepItem>
        ))}
      </StepList>
    </LoadingInvoiceContainer>
  );
};
